import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71dc3dfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container portfolio-container" }
const _hoisted_2 = { class: "columns is-multiline is-variable is-6-mobile" }
const _hoisted_3 = { class: "column is-one-third" }
const _hoisted_4 = { class: "card my-card" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>Themos Vagas</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Desktop</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Mobile</span></span></p></header>", 1)
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content has-text-justified" }, " Projeto de renovação do themos vagas o canal mais famoso do piauí de vagas de emprego. O projeto ainda está em andamento e ainda não se encontra em produção, mas logo abaixo temos uma versão beta para visualização. Esse projeto gerido por mim como programador fullstack, onde trabalhei no back-end com Django e Django rest-framework, no front foi usado html, css e javascript puro, mas a intenção é migrar todas as telas para react ou vue. O banco de dados escolhido foi o postgresql, todas as tabelas foram modeladas por mim. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://themosvagas.herokuapp.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "card-footer-item"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "card-footer-item",
    "aria-disabled": "true"
  }, "Source Code: Privado")
], -1))
const _hoisted_11 = { class: "column is-one-third" }
const _hoisted_12 = { class: "card my-card" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>API Whatsapp</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Api Rest</span></span></p></header>", 1)
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content has-text-justified margin-top" }, " Projeto desenvolvido para ser usado em conjunto com um chatbot criado em Python. Esta é uma API não oficial do WhatsApp para enviar mensagens, receber e replicar outras funcionalidades que o WhatsApp possui através de uma API REST. Foi desenvolvido inteiramente por mim para a empresa RevGás, a fim de testarmos o bot para futuramente migrarmos para a API oficial do WhatsApp. ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "card-footer-item",
    href: "https://github.com/joaovitor27/project_api_whatsapp",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Sem Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/joaovitor27/project_api_whatsapp",
    class: "card-footer-item",
    "aria-disabled": "true",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Source Code")
], -1))
const _hoisted_19 = { class: "column is-one-third" }
const _hoisted_20 = { class: "card my-card" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>Rastreador Front-end</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Desktop</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Mobile</span></span></p></header>", 1)
const _hoisted_22 = { class: "card-content" }
const _hoisted_23 = { class: "image" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content has-text-justified margin-top" }, " Projeto pessoal com o intuito de desenvolver um rastreador para colocar em meus veículos e também adquirir mais conhecimento. O frontend é feito com Vue.js, o qual consome uma API em Python com o framework FastAPI, também desenvolvida por mim. O projeto está em fase de desenvolvimento e está parado na parte física do projeto, que é o rastreador. ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://rastreamento-web.vercel.app/",
    class: "card-footer-item",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "card-footer-item"
  }, "Source Code: Privado")
], -1))
const _hoisted_27 = { class: "column is-one-third" }
const _hoisted_28 = { class: "card my-card" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>Rastreador Back-end</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Api Rest</span></span></p></header>", 1)
const _hoisted_30 = { class: "card-content" }
const _hoisted_31 = { class: "image" }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content has-text-justified margin-top" }, " Projeto pessoal com o intuito de desenvolver um rastreador para colocar em meus veículos e também adquirir mais conhecimento. O backend é feito com Python usando o framework FastAPI, com banco de dados PostgreSQL. O backend é responsável por gerenciar todos os usuários e dispositivos rastreadores e enviar dados para o frontend. O projeto está em fase de desenvolvimento, com a parte física do rastreador ainda pendente. ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://rastreamento-web.vercel.app/",
    class: "card-footer-item",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "card-footer-item"
  }, "Source Code: Privado")
], -1))
const _hoisted_35 = { class: "column is-one-third" }
const _hoisted_36 = { class: "card my-card" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>Portfólio Frot-end</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Desktop</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>Mobile</span></span></p></header>", 1)
const _hoisted_38 = { class: "card-content" }
const _hoisted_39 = { class: "image" }
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content has-text-justified margin-top",
  style: {"margin-top":"10px"}
}, " Projeto pessoal com intuito de apresentar meu currículo e meus projetos. O front é feito com Vue.js. ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://portifolio-joaovitor27.vercel.app/",
    class: "card-footer-item",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/joaovitor27/portifolio",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "card-footer-item"
  }, "Source Code")
], -1))
const _hoisted_43 = { class: "column is-one-third" }
const _hoisted_44 = { class: "card my-card" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<header class=\"card-header\" data-v-71dc3dfb><p class=\"card-header-title\" data-v-71dc3dfb><span class=\"margin-right-10-px\" data-v-71dc3dfb>Portfólio Back-end</span><span class=\"is-pulled-right\" data-v-71dc3dfb><span class=\"tag is-default full-margin\" data-v-71dc3dfb>v1.0.0</span><span class=\"tag is-default full-margin\" data-v-71dc3dfb>API Rest</span></span></p></header>", 1)
const _hoisted_46 = { class: "card-content" }
const _hoisted_47 = { class: "image" }
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content has-text-justified margin-top" }, " Projeto pessoal com o intuito de apresentar meu currículo e meus projetos. O backend é feito com Python usando o Django Rest Framework, com banco de dados PostgreSQL. O backend é responsável por gerenciar todos os dados do portfólio e enviar para o frontend. ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/joaovitor27/api_portfolio",
    class: "card-footer-item",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/joaovitor27/api_portfolio",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "card-footer-item"
  }, "Source Code")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("figure", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.ThemosVagas,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_8)
            ]),
            _hoisted_9
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("figure", _hoisted_15, [
              _createElementVNode("img", {
                src: _ctx.ApiWhatsapp,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_16)
            ]),
            _hoisted_17
          ]),
          _hoisted_18
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("figure", _hoisted_23, [
              _createElementVNode("img", {
                src: _ctx.RastreamentoWeb,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_24)
            ]),
            _hoisted_25
          ]),
          _hoisted_26
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("figure", _hoisted_31, [
              _createElementVNode("img", {
                src: _ctx.RastreamentoBack,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_32)
            ]),
            _hoisted_33
          ]),
          _hoisted_34
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("figure", _hoisted_39, [
              _createElementVNode("img", {
                src: _ctx.Portfolio,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_40)
            ]),
            _hoisted_41
          ]),
          _hoisted_42
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("figure", _hoisted_47, [
              _createElementVNode("img", {
                src: _ctx.PortfolioBack,
                alt: "Landing template screenshot"
              }, null, 8, _hoisted_48)
            ]),
            _hoisted_49
          ]),
          _hoisted_50
        ])
      ])
    ])
  ]))
}